import { Component, OnInit, Output, EventEmitter, OnDestroy } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, UntypedFormControl } from '@angular/forms';
import { Consumption } from '../Models/Consumption';
import { ConsumptionPeriod } from '../Models/ConsumptionPeriod';
import { PHBHPLayoutPackageService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { PHBHPFeaturePackageConsumptionService } from './../ph-bhp-feature-package-consumption.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { TranslationKeys } from 'ph-bhp-localization';

@Component({
  selector: 'lib-ph-bhp-view-year-consumption',
  templateUrl: './ph-bhp-view-year-consumption.component.html',
  styleUrls: ['./ph-bhp-view-year-consumption.component.css']
})
export class PhBhpViewYearConsumptionComponent implements OnInit, OnDestroy {
  subscription: Subscription;
  isMilliliter = true;
  isLiter = true;
  viewFlag: string = 'liter';
  periodInYearForm: UntypedFormGroup;
  consumptionJsonData;
  consumptionID: number;
  providerNumber: 1;
  haiOccurrences: number;
  haiEnabled: boolean = false;
  consumptionData: Array<Consumption> = [];
  consumptionPeriodData: Array<ConsumptionPeriod> = [];
  consumptionPeriodDetail: any = [];
  consumptionPeriodDetailNew: ConsumptionPeriod;
  consumptionConfigDetail: Array<any> = [];
  viewConsumption: boolean = false;
  editconsumptionDisabled: boolean = false;
  @Output() childData = new EventEmitter();
  translationKeys: typeof TranslationKeys = TranslationKeys;
  consumptionYearConfiguration: any;

  constructor(private service: PHBHPFeaturePackageConsumptionService, private router: Router, private fb: UntypedFormBuilder, private activatedRoute: ActivatedRoute, private layoutService: PHBHPLayoutPackageService) { }

  ngOnInit() {
    this.consumptionID = parseInt(this.activatedRoute.snapshot.paramMap.get('Id'));
    if (this.layoutService.institutionID) {
      this.getConsumptionConfigByInstitutionIdList();
      this.getConsumptionPeriodLis();
    }
    this.subscription = this.layoutService.institutionIDSubject.asObservable().subscribe((Id) => {
      this.layoutService.institutionID = Id;
      this.getConsumptionConfigByInstitutionIdList();
      this.getConsumptionPeriodLis();
      this.router.navigate(['/consumption/new']);
    });

    this.periodInYearForm = new UntypedFormGroup({
      consumptionValue: new UntypedFormControl({
        value: '',
        disabled: true
      }),
      patientDays: new UntypedFormControl({
        value: '',
        disabled: true
      }),
      haiOccurrences: new UntypedFormControl({
        value: '',
        disabled: true
      })
    });
  }
  ngOnDestroy() {
    if (this.subscription)
      this.subscription.unsubscribe();
  }
  getConsumptionPeriodLis() {
    this.service.getConsumptionPeriodById(this.consumptionID).subscribe((res: Array<ConsumptionPeriod> = []) => {
      this.consumptionPeriodDetail = res;
      this.consumptionPeriodDetailNew = res[0];
      this.periodInYearForm.patchValue({
        consumptionValue: this.consumptionPeriodDetail[0].consumptionValue,
        patientDays: this.consumptionPeriodDetail[0].patientDays,
        periodNumber: this.consumptionPeriodDetail[0].periodNumber,
        haiOccurrences: this.consumptionPeriodDetail[0].haiOccurrences || ''
      });
    });
  }

  amountMeasure() {
    if (this.consumptionYearConfiguration?.amountMeasured === 'u') {
      return this.layoutService.translateText('CONSUMPTION.USED.DISPLAY_TEXT');
    } else if (this.consumptionYearConfiguration?.amountMeasured === 'p') {
      return this.layoutService.translateText('CONSUMPTION.PURCHASED.DISPLAY_TEXT');
    }
  }

  unitMeasure() {
    if (this.consumptionYearConfiguration?.unitOfMeasure === 'l') {
      return this.layoutService.translateText(this.translationKeys.Dashboard.inLiters);
    } else if (this.consumptionYearConfiguration?.unitOfMeasure === 'm') {
      return this.layoutService.translateText('CONSUMPTION.AMOUNT.IN_MILLILITERS');
    }
  }


  EditConsumption() {
    this.editconsumptionDisabled = true;
    this.viewConsumption = true;
    this.periodInYearForm.get('consumptionValue').enable();
    this.periodInYearForm.get('patientDays').enable();
    if (this.haiEnabled) {
      this.periodInYearForm.get('haiOccurrences').enable();
    }
    this.childData.emit({
      key: true
    })
  }

  SaveNewConsumption() {
    var id = this.consumptionID;
    if (this.periodInYearForm.value.consumptionValue == "" && this.periodInYearForm.value.patientDays == "") {
      this.periodInYearForm.value.consumptionValue = 0;
      this.periodInYearForm.value.patientDays = 0;
      this.periodInYearForm.value.haiOccurrences = 0;
    }
    if (this.periodInYearForm.value.consumptionValue == null && this.periodInYearForm.value.patientDays == null) {
      this.periodInYearForm.value.consumptionValue = 0;
      this.periodInYearForm.value.patientDays = 0;
      this.periodInYearForm.value.haiOccurrences = 0;
    }
    var data = [{
      consumptionID: this.consumptionID,
      consumptionPeriodID: this.consumptionPeriodDetail[0].consumptionPeriodID,
      consumptionValue: this.periodInYearForm.value.consumptionValue,
      patientDays: this.periodInYearForm.value.patientDays,
      haiOccurrences: this.periodInYearForm.value.haiOccurrences,
      periodNumber: 1
    }]
    this.service.updateConsumptionPeriodById(id, data).subscribe((res: any) => {
      this.childData.emit({
        key: false,
        val: "save"
      })
      // this.layoutService.showSuccess(this.layoutService.translateText("CONSUMPTION.CONSUMPTION.SUCCESSFULLY_UPDATED_DETAILS"));
      this.router.navigate(['/consumption/past']);
    })
  }

  updateConsumptionPeriod() {
    this.convertCommaToDot();
    this.periodInYearForm.value.consumptionID = this.consumptionID;
    var formValue1: Boolean = false;
    var consumptionValueFlag: Boolean = false;
    var patientDaysFlag: Boolean = false;

    if (this.periodInYearForm.value.consumptionValue == null) {
      this.periodInYearForm.value.consumptionValue = "";
    }
    if (this.periodInYearForm.value.patientDays == null || this.periodInYearForm.value.patientDays == 0) {
      this.periodInYearForm.value.patientDays = "";
    }
    if (!this.haiEnabled || (this.haiEnabled && (this.periodInYearForm.value.haiOccurrences == null || this.periodInYearForm.value.haiOccurrences == 0))) {
      this.periodInYearForm.value.haiOccurrences = "";
    }

    if (this.periodInYearForm.value.consumptionValue != "" && this.periodInYearForm.value.patientDays == "") {
      patientDaysFlag = true;
    } else if (this.periodInYearForm.value.consumptionValue == "" && this.periodInYearForm.value.patientDays != "") {
      consumptionValueFlag = true;
    } else if (this.periodInYearForm.value.consumptionValue != "" && this.periodInYearForm.value.patientDays != "") {
      formValue1 = true;
    }

    if (patientDaysFlag) {
      this.layoutService.showError(this.layoutService.translateText("CONSUMPTION.SUBMISSION_RULE.MISSING_PATIENT_DAYS"));
    } else if (consumptionValueFlag) {
      if (this.consumptionConfigDetail[0].amountMeasured == "u") {
        this.layoutService.showError(this.layoutService.translateText("CONSUMPTION.SUBMISSION_RULE.MISSING_USED_DATA"));
      } else if (this.consumptionConfigDetail[0].amountMeasured == "p") {
        this.layoutService.showError(this.layoutService.translateText("CONSUMPTION.SUBMISSION_RULE.MISSING_PURCHASED_DATA"));
      }
    } else if (formValue1) {
      this.SaveNewConsumption()
    } else {
      this.layoutService.showError(this.layoutService.translateText("CONSUMPTION.NO_CHANGES_TO_SAVE"));
    }
  }

  convertCommaToDot() {
    this.periodInYearForm.value.consumptionValue = this.periodInYearForm.value.consumptionValue.toString().replace(',', '.');
  }

  cancelConsupmtionPeriod() {
    this.getConsumptionPeriodLis()
    this.editconsumptionDisabled = false;
    this.viewConsumption = false;
    this.childData.emit({
      key: false,
      val: "cancel"
    })
  }

  getConsumptionConfigByInstitutionIdList() {
    this.service.getSOPConsumptionByConsumptionId(this.consumptionID).subscribe((res: any) => {
      this.consumptionData = res;
      this.service.getConsumptionConfigByInstitutionId(this.layoutService.institutionID).subscribe((res: Array<any> = []) => {
        this.consumptionConfigDetail[0] = res;
        this.consumptionYearConfiguration = this.service.getConsumptionYearConfiguration(this.consumptionConfigDetail[0].consumptionConfigs, this.consumptionData[0].year)
        this.haiEnabled = this.consumptionConfigDetail[0].enableHAITracking;
      });
    });
  }
  isLiters() {
    return this.consumptionYearConfiguration?.unitOfMeasure === 'l';
  }

  isMilliliters() {
    return this.consumptionYearConfiguration?.unitOfMeasure === 'm';
  }
}
